module.exports = __webpack_public_path__ + "img/logo-tds-orange.1af598a6.svg";